import { Pipe, PipeTransform } from '@angular/core';
import { AssetUIModel, getAssetPublishingMessage } from '@thehubz/client/core';

@Pipe({
  name: 'assetPublishingMessage',
  standalone: true,
})
export class AssetPublishingMessagePipe implements PipeTransform {
  /**
   * Asset publishing message pipe to display the message based on the asset publishing start and/or end dates
   */
  transform(asset: AssetUIModel): string {
    return getAssetPublishingMessage(asset);
  }
}
